import {
  LOG_OUT,
  GET_SINGLE_RSVP_EVENT_INFORMATION,
  GET_SINGLE_RSVP_EVENT_PENDING,
  GET_SINGLE_RSVP_EVENT_RSVP,
  GET_SINGLE_RSVP_EVENT_TICKET,
  GET_SINGLE_RSVP_EVENT_HISTORY,
  GET_SINGLE_RSVP_EVENT_ALL,
  TRANSACTION_ID,
} from "../../types";

const initialState = {
  get_single_event_info: {},
  single_rsvp_event_pending: [],
  single_rsvp_event_rsvp: [],
  single_rsvp_event_ticket: [],
  single_rsvp_event_history: [],
  single_rsvp_event_all: [],
  transactional_id: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_SINGLE_RSVP_EVENT_INFORMATION:
      return {
        ...state,
        get_single_event_info: action.payload,
      };
    case GET_SINGLE_RSVP_EVENT_PENDING:
      return {
        ...state,
        single_rsvp_event_pending: action.payload,
      };
    case GET_SINGLE_RSVP_EVENT_RSVP:
      return {
        ...state,
        single_rsvp_event_rsvp: action.payload,
      };
    case GET_SINGLE_RSVP_EVENT_TICKET:
      return {
        ...state,
        single_rsvp_event_ticket: action.payload,
      };
    case GET_SINGLE_RSVP_EVENT_HISTORY:
      return {
        ...state,
        single_rsvp_event_history: action.payload,
      };
    case GET_SINGLE_RSVP_EVENT_ALL:
      return {
        ...state,
        single_rsvp_event_all: action.payload,
      };
    case TRANSACTION_ID:
      return {
        ...state,
        transactional_id: action.payload,
      };
    case LOG_OUT: {
      return {
        ...state,
        get_single_event_info: {},
        single_rsvp_event_pending: [],
        single_rsvp_event_rsvp: [],
        single_rsvp_event_ticket: [],
        single_rsvp_event_history: [],
        single_rsvp_event_all: [],
      };
    }
    default:
      return state;
  }
}
